import api from '@/api'

export default {
    namespaced: true,
    state: {},
    actions: {
        /**
         * NOTE: 申請加入頻道
         * @return {Object}
         */
        async applyChannel({dispatch, rootState}, schoolCode) {
            // 檢查是否需要重置AccessToken
            await dispatch('coreApi/refreshAccessToken', null, {root: true})
            return new Promise(function(resolve) {
                api.sokplatformApi.applyChannel(rootState.coreApi.tokens, schoolCode).then(() => {
                    resolve(true)
                }).catch(() => {
                    resolve(true)
                })
            })
        },
    },
}